import { createFileRoute } from '@tanstack/react-router'
import { CustomerCampaignsPage } from '@/features/customer/pages/campaigns'

export const Route = createFileRoute('/_authenticated/customer/campaigns/')({
  component: CustomerCampaignsPage,
})

